import { CustomDialog } from "components/dialogs/Dialogs";
import { intl } from "LocaleWrapper";
import DatePicker from "components/cck/DatePicker";
import { Button } from "@cofano/cck";

type EstimateTimeDialogProps = {
	open: boolean;
	onClose: () => void;
	onUpdate: () => void;
	value?: number;
	setValue: (value?: number) => void;
}

const CustomerUpdateEstimateTimeDialog = ({ open, onClose, onUpdate, value, setValue }: EstimateTimeDialogProps) => {
	return (
		<CustomDialog maxWidth="sm"
			open={open}
			onClose={onClose}
			title={intl.formatMessage({ id: "ESTIMATE" })}
			actions={<>
				<Button onClick={onUpdate}>
					{intl.formatMessage({ id: "SAVE" })}
				</Button>
			</>}>
			<DatePicker
				value={value ?? null}
				onChange={(val) => setValue(val ?? undefined)}
				showTimeInput
				autoFocus />
		</CustomDialog>
	);
};

export default CustomerUpdateEstimateTimeDialog;
